module.exports = __webpack_public_path__ + "img/nvidia-logo.c77436ff.png";